module.exports = __webpack_public_path__ + "img/picture_44.ee0e53fa.png";